export default defineNuxtRouteMiddleware(async (to, _from) => {
  // This middleware runs on client-side transitions as well as initial page loads

  // Check if this is a subscribe page or a category page
  const isSubscribePage = to.path.startsWith('/subscribe')
  const isCategoryPage = /^\/[\w-]+$/.test(to.path)
  const hasEmailParam = !!to.query.email

  // Get email param from route if any
  const email = to.query.email ? String(to.query.email) : null

  // Check if this is a flow resumption - if so, we'll skip protection checks
  const isResumingFlow = to.query.flow_resumed === 'true'

  // Only run checks for subscribe pages and category pages with email param
  if ((isSubscribePage || isCategoryPage) && hasEmailParam && !isResumingFlow) {
    try {
      console.log('Running subscribe protection middleware')

      // Get the fingerprint from the security module
      const { getSecurityData } = useSecurityChecks()
      const fingerprint = getSecurityData().fp

      // Check if this browser has already subscribed
      const statusCheck = await $fetch('/api/subscribe/check-status', {
        method: 'POST',
        body: {
          email: email || 'none', // Provide a value to avoid errors
          fingerprint,
        },
      })

      // If the browser has already subscribed with any email
      if (statusCheck.exists && statusCheck.status === 'browser_subscribed') {
        const toast = useToast()
        toast.add({
          title: 'Already subscribed',
          description: "You've already subscribed",
          color: 'primary',
          timeout: 5000,
        })

        // Check if the current email matches the subscribed email
        // If it does, allow a flow resumption
        if (statusCheck.subscribedEmail === email) {
          console.log(
            'Email matches existing subscription, allowing as flow resumption',
          )
          // Add the flow_resumed param to the current route
          return navigateTo({
            path: to.path,
            query: { ...to.query, flow_resumed: 'true' },
          })
        }

        // If they're navigating to a subscribe page or category page, redirect to home
        if (
          to.path !== '/' &&
          (to.path.match(/^\/[\w-]+$/) || to.path.startsWith('/subscribe'))
        ) {
          return navigateTo('/')
        }
      }
    } catch (error) {
      console.error('Error checking subscription status:', error)
      // Continue anyway - this is just an additional protection layer
    }
  }
})
